import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/terms-guide")({
  component: lazyRouteComponent(() => import("./-pages/admin.terms-guide")),
  head: () => ({
    meta: [
      { title: "دليل المصطلحات · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
